<template>
    <footer class="footer text-center bg-grey md:p-[20px] p-[10px] text-[12px] left-[0] bottom-[0] w-full z-[10]">
        <ul class="flex md:flex-row flex-col justify-center md:gap-[20px] gap-[5px]">
            <li>© KPMG 2024 - All rights reserved</li>
            <li>
                <a href="https://kpmg.com/uk/en/home/misc/privacy.html" target="_blank">
                    Privacy & data protection
                </a>
            </li>
            <li>
                <a href="https://kpmg.com/uk/en/home/misc/cookies.html" target="_blank">
                    Cookie Policy
                </a>
            </li>
        </ul>
    </footer>
</template>

<script>
    export default {
        name: 'FooterSection'
    }
</script>